export default __webpack_public_path__ + "static/media/crossroads3.939cb809.webp";